import React, { Component } from "react";
import styled from "styled-components";

class contactdetailscard extends Component {
  constructor() {
    super();
  }
  render() {
    const OneDetailsCard = styled.div`
      text-align: left;
      border-radius: 4px;

      color: #000;
      font-family: Lato;
      font-size: 16px;
      letter-spacing: -0.01px;
      line-height: 19px;
    `;

    const OneDetailsCardHead = styled.div`
      border-radius: 6px 6px 0 0;
      background-color: #e1e1e1;
      border: 1px solid #f6f6f6;
      text-align: left;
      padding: 1.5%;

      color: #000;
      font-family: Lato;
      font-size: 18px;
      letter-spacing: -0.01px;
      line-height: 19px;
      text-transform: uppercase;
      font-weight:500;
    `;
    const OneDetailsCardDetails = styled.div`
      border-radius: 6px 6px 0 0;
      background-color: #fff;
      border: 1px solid #f6f6f6;
      text-align: left;
      padding: 4%;

      color: #000;
      font-family: Lato;
      font-size: 16px;
      letter-spacing: -0.01px;
      line-height: 19px;
    `;
    const ImageIcon = styled.div`
    list-style-image: url("../images/ui-icon2.svg");
    `;
    return (
      <OneDetailsCard>
        <OneDetailsCardHead>
          <text>{this.props.detailtitle}</text>
        </OneDetailsCardHead>
        <OneDetailsCardDetails>
          <ImageIcon>
            {this.props.detail1 ? (
              <li style={{ listStyleType: "disc" }}>{this.props.detail1}</li>
            ) : (
              ""
            )}
            {this.props.detail2 ? (
              <li style={{ listStyleType: "disc" }}>{this.props.detail2}</li>
            ) : (
              ""
            )}
            {this.props.detail3 ? (
              <li style={{ listStyleType: "disc" }}>{this.props.detail3}</li>
            ) : (
              ""
            )}
          </ImageIcon>
        </OneDetailsCardDetails>
      </OneDetailsCard>
    );
  }
}

export default contactdetailscard;
